<template>
  <section>
    <v-dialog
      v-model="showModal"
      max-width="700px"
    >
      <v-card
        color="#ECEFF1"
      >
        <br>
        <h2 class="modal-title-style">
          <v-icon class="modal-icon-style">
            mdi-phone
          </v-icon> Contact Us
          <v-icon
            class="close-button"
            @click="showModal = false"
          >
            mdi-window-close
          </v-icon>
        </h2>
        <v-card-text>
          <v-form>
            <v-container>
              <div class="div-style">
                <p
                  class="my-p-style"
                >
                  <font>
                    To cancel this device time slot subscription, Please  contact us at
                  </font>
                </p>
                <p
                  class="contact-style"
                >
                  <font>
                    <v-icon color="#37474F">
                      mdi-email
                    </v-icon>
                    info@dibasys.com
                  </font>
                </p>
                <p
                  class="contact-style"
                >
                  <font>
                    <v-icon color="#37474F">
                      mdi-phone
                    </v-icon>
                    +9180 8963 0261 (India)
                  </font>
                </p>
              </div>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>

export default {
  name: 'ContactForSubCancel',

  data () {
    return {
      showModal: true,
    };
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
};
</script>
<style scoped>
.my-p-style {
  font-size: 20px;
  font-weight: bold;
  color: #ff3700;
  font-family:'Times New Roman', Times, serif;
}
.modal-title-style {
  color: #37474F;
  margin-left: 30px;
}
.modal-icon-style {
  color: #37474F;
  font-size: 45px;
}
.div-style {
    text-align: center;
}
.contact-style {
    font-size: 18px;
    color: #37474F;
    font-weight: bold;
    font-family: 'Times New Roman', Times, serif;
}
.close-button {
    float: right;
    margin-right: 20px;
    cursor: pointer;
    color: #37474F;
}
</style>
